import { render, staticRenderFns } from "./project-overview-header.vue?vue&type=template&id=1da552bb"
import script from "./project-overview-header.ts?vue&type=script&lang=ts&external"
export * from "./project-overview-header.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports